<span class="text-time-ago">
  {{ timeAgo }}
</span>
